import axios from 'axios'
import { VALIDATE_INFORMATION_CONTRIBUTOR } from 'constants/endpoints'

const axiosClient = axios.create()

export const validateInformationContributor = async payload => {
   const {
      registerType: thirdPartyType,
      legalNature: personType,
      email: username,
      documentNumber,
      documentType
   } = payload
   const body = {
      thirdPartyType,
      personType,
      documentType,
      documentNumber,
      username
   }
   const endpoint = `${process.env.REACT_APP_CONTRIBUTOR_API}${VALIDATE_INFORMATION_CONTRIBUTOR}`
   const { data = {} } = await axiosClient.post(endpoint, body)
   return { data }
}
